import * as yup from 'yup';

export const slackLinkSchema = yup
  .string()
  .url('Must be a valid URL')
  .test('slack_link', 'Must be a valid slack link', value => {
    try {
      // because it's optional
      if (!value) {
        return true;
      }
      const url = new URL(value);
      const isCorrectProtocol = ['https:', 'http:'].includes(url.protocol);
      const isCorrectHost = url.host.endsWith('slack.com');

      return isCorrectProtocol && isCorrectHost;
    } catch {
      return false;
    }
  })
  .optional();
